/* global axios */
import ApiClient from './ApiClient';

class DataSyncConfigAPI extends ApiClient {
  constructor() {
    super('data_sync_config', { accountScoped: true });
  }

  getConfig() {
    return this.get();
  }

  updateConfig(payload) {
    return this.update('', payload);
  }

  testConnection(payload) {
    return axios.post(`${this.url}/test_connection`, payload);
  }
}

export default new DataSyncConfigAPI();
